import { MODULE_NAME } from './const';
import { SET_FOCUSED_ELEMENT } from './mutations';
import StoreModuleService from '../StoreModuleService';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const setFocusedElement = buildActionObject('setFocusedElement');

const actions = {
	...StoreModuleService.createDefaultActions(),

	[setFocusedElement.action]({ commit }, payload) {
		commit(SET_FOCUSED_ELEMENT, payload);
	},
};

export default actions;
